const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_RETRY_DELAY = 500; // ms

export const loadRecaptcha = (
    maxRetries: number = DEFAULT_MAX_RETRIES,
    retryDelay: number = DEFAULT_RETRY_DELAY
): Promise<void> => {
    let attempt = 0;

    function tryLoad(resolve: () => void, reject: (error: any) => void) {
        if (window.grecaptcha) {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js`;
        script.async = true;
        script.defer = true;

        script.onload = () => resolve();
        script.onerror = (error) => {
            script.remove();
            attempt++;
            if (attempt <= maxRetries) {
                setTimeout(() => tryLoad(resolve, reject), retryDelay);
            } else {
                reject(error);
            }
        };

        document.head.appendChild(script);
    }

    return new Promise((resolve, reject) => {
        tryLoad(resolve, reject);
    });
};
